import { CRUDEntity } from "../../abstracts/CRUDEntity";

export class UsageSettings extends CRUDEntity{
    constructor(){
        super();
        this.entityClass = 'usage-setting';
        this.urlRoot = '/settings/usage';
        this.sectionRootUrl = '/settings';

    }
}
